import type { IInvestmentProposalRepository } from "@/application/ports/repositories";
import type {
  InvestmentProposalCreateRequest,
  InvestmentProposalResponse,
  InvestmentProposalListResponse,
} from "@/domain/investmentProposal";
import * as sdk from "../generated/sdk.gen";
import { unwrap } from "../unwrap";

export class InvestmentProposalRepository implements IInvestmentProposalRepository {
  async createProposal(data: InvestmentProposalCreateRequest): Promise<InvestmentProposalResponse> {
    return unwrap(sdk.createProposal({ body: data }));
  }

  async getProposals(params?: {
    limit?: number;
    offset?: number;
  }): Promise<InvestmentProposalListResponse> {
    const { items, ...rest } = await unwrap(sdk.listProposals({ query: params }));
    return { proposals: items, total: rest.total_count, limit: rest.limit, offset: rest.offset };
  }

  async getProposal(uuid: string, token: string): Promise<InvestmentProposalResponse> {
    return unwrap(sdk.getProposal({ path: { proposal_uuid: uuid }, query: { token } }));
  }

  async acceptProposal(uuid: string, token: string): Promise<void> {
    await unwrap(sdk.acceptProposal({ path: { proposal_uuid: uuid }, query: { token } }));
  }

  async declineProposal(uuid: string, token: string): Promise<void> {
    await unwrap(sdk.declineProposal({ path: { proposal_uuid: uuid }, query: { token } }));
  }
}
